import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core'
import { AmChartsService } from '@amcharts/amcharts3-angular'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'

import { ActivatedRoute } from '@angular/router'

// import { ExportExcelService } from 'app/service/export-excel.service'
import { ExportPPTService } from 'app/service/export-ppt.service'
@Component({
  selector: 'app-existing-listed-securities',
  templateUrl: './existing-listed-securities.component.html',
  styleUrls: ['./existing-listed-securities.component.scss']
})
export class ExistingListedSecuritiesComponent implements OnInit, OnDestroy, AfterViewInit {
  startYear = 1975
  endYear
  listedSecurities = []
  getPrint
  listNewIpo = []
  chartExisting
  dataChart
  pdfChart: PdfChart = new PdfChart()
  dataProvider = []
  tradingDate
  year
  listedSecuritiesByType
  ipoSecuritiesByType
  constructor(
    private amCharts: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private pptService: ExportPPTService
  ) { }

  ngOnInit() {
    const { print, pdf } = this.activatedRoute.snapshot.data
    this.getPrint = print

    this.pdfChart.setPdf(pdf)
    if (print || pdf) {
      this.setDataGraph(this.startYear)
    }
  }

  async setDataGraph(startYear) {
    await this.getLastTradingDate();
    this.listedSecurities = []
    this.listNewIpo = []
    Promise.all([
      this.getLastTradingDate(),
      this.cpmService.getListedSecuritiesByYear(startYear, this.endYear),
      this.cpmService.getNewIpoByYear(startYear, this.endYear),
      this.cpmService.getListedSecuritiesByType(this.endYear),
      this.cpmService.getIPOSecuritiesByType(this.endYear)
    ]).then(([lastTradingDate, listedSecurities, listNewIpo, listedSecuritiesByType, ipoSecuritiesByType]) => {
      this.year = lastTradingDate
      this.listedSecurities = listedSecurities
      this.listNewIpo = listNewIpo
      this.listedSecuritiesByType = listedSecuritiesByType
      this.ipoSecuritiesByType = ipoSecuritiesByType
      this.markChart()
    })
  }
  markChart() {
    this.dataProvider = this.listedSecurities.map(se => {
      const data = {}
      data['year'] = se.year
      data['securities'] = se.noListedCompany
      const ipo = this.listNewIpo.find(obj => obj.year === se.year)
      data['newIpo'] = ipo.noListedCompany
      return data
    })
    const years = this.dataProvider.map(it => it.year)
    const maxYear = Math.max(...years)
    this.dataProvider[
      this.dataProvider.findIndex(it => it.year === maxYear)
    ].last = true

    this.dataChart = {
      type: 'serial',
      theme: 'light',
      fontFamily: 'browallia',
      fontSize: 18,
      precision: 0,
      valueAxes: [
        {
          id: 'v1',
          stackType: 'regular', // add for stackType
          title: 'Number of new IPO',
          position: 'right',
          autoGridCount: false
        },
        {
          id: 'v2',
          title:
            'Number of listed securities' +
            '\n' +
            '(Common stock and PF/REITs)',
          size: 10,
          gridAlpha: 0,
          position: 'left',
          autoGridCount: false,
          axisAlpha: 1
        }
      ],
      graphs: [
        {
          id: 'g1',
          valueAxis: 'v1',
          lineColor: '#FFBF00',
          fillColors: '#FFBF00',
          fillAlphas: 1,
          type: 'column',
          title: ' Number of new IPO (Right)',
          valueField: 'newIpo',
          clustered: false,
          columnWidth: 0.2,
          legendValueText: '[[value]]',
          balloonText: '<b style="font-size: 100%">[[value]]</b>',
          labelPosition: 'top',
          labelText: '[[value]]',
          labelFunction: (data, txt) => (data.dataContext.last ? txt : '')
        },
        {
          id: 'g5',
          valueAxis: 'v2',
          bullet: 'round',
          bulletBorderAlpha: 1,
          bulletColor: '#101907',
          bulletSize: 5,
          hideBulletsCount: 50,
          lineThickness: 2,
          lineColor: '#0000ff',
          type: 'smoothedLine',
          title:
            ' Number of listed securities (Common stock and PF/REITs) (Left)',
          useLineColorForBulletBorder: true,
          valueField: 'securities',
          balloonText: '<b style="font-size: 100%">[[value]]</b>',
          labelText: '[[value]]',
          labelFunction: (data, txt) => (data.dataContext.last ? txt : '')
        }
      ],
      chartCursor: {
        pan: true,
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        valueLineAlpha: 0.2
      },
      categoryField: 'year',
      categoryAxis: {
        gridAlpha: 0.07,
        axisColor: '#DADADA',
        startOnAxis: false,
        title: 'Year',
        autoGridCount: true
      },
      legend: {
        useGraphSettings: true,
        position: 'bottom',
        align: 'center'
      },
      balloon: {
        borderThickness: 1,
        shadowAlpha: 0
      },
      export: {
        enabled: false,
        menu: [
          {
            class: 'export-main',
            menu: [
              {
                format: 'PDF',
                fileName: 'Historical data',
                content: [{ image: 'reference', fit: [523.28, 769.89] }]
              }
            ]
          }
        ]
      },
      titles: [
        {
          id: 'Title-1',
          size: 18,
          text: 'New and existing listed securities'
        }
      ],
      dataProvider: this.dataProvider
    }
    this.chartExisting = this.amCharts.makeChart(
      'existingListedSecuritiesChartdiv',
      this.dataChart
    )
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    this.endYear = lastTrading.getFullYear()
    return lastTrading.getFullYear()
  }

  Ppt() {
    this.pptService.pptExistingListedSecurities(this.dataProvider, this.listedSecuritiesByType, this.ipoSecuritiesByType)
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

  ngOnDestroy() {
    if (
      this.chartExisting &&
      this.chartExisting.legend &&
      this.chartExisting.legend.destroy
    ) {
      const tmp =
        this.chartExisting != null
          ? this.amCharts.destroyChart(this.chartExisting)
          : null
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/existing-listed-securities/existing-listed-securities.component.ts